module.exports = __webpack_public_path__ + "static/acceptore-logo-12273973027ddfe38396345a2a68760a.svg";